import React, { Component } from 'react';
import { CookiesProvider } from 'react-cookie';
import axios from 'axios';
import Header from '../../../Components/V2/Header';
import Footer from '../../../Components/V2/Footer';
import Title from '../../../Components/V2/Category/Title';
import Pagination from '../../../Components/V2/Category/Pagination';
import Article from '../../../Components/V2/Category/Article';
import Social from '../../../Components/V2/Category/Social';
import './style.scss';
export default class SpecializedNews extends Component {
  constructor(props) {
    super(props);
    this.state = {
      category: {},
      articles: [],
      latest: [],
      trending: [],
      currentPage: 1,
      totalPage: 0,
    };
  }

  componentDidMount() {
    //call api
    this.getArticlesCategory(1);
  }

  getArticlesCategory = (page) => {
    const { match } = this.props;
    console.log(page);
    axios
      .get(
        `/api/v1/articles/article-specialized/${match.params.category_slug}`,
        {
          params: {
            page: page,
            limit: 10,
          },
        }
      )
      .then(({ data }) => {
        if (data.success) {
          this.setState({
            category: data.payload.category,
            articles: data.payload.articles,
            currentPage: page,
            totalPage: data.payload.total,
          });
        }
      });
  };

  render() {
    return (
      <CookiesProvider>
        <div className='category-page'>
          <Header />
          {/* <Intro /> */}
          <div className='container'>
            <a
              href='https://www.saobacdautelecom.vn?utm-source=smedx'
              target='_blank'
            >
              <img src='/smedx/banners/ai-marketing-top.png' width='100%' />
            </a>
          </div>
          {/* <Title title={this.state.category.category_name} /> */}
          <main className='main_content sidebar_right pb-50'>
            <div class='container'>
              <div class='row'>
                <div class='col-lg-8 col-md-12 col-sm-12'>
                  <div class='loop-grid row'>
                    {this.state.articles.map((item) => (
                      <Article key={item.id} item={item} />
                    ))}
                  </div>
                  <Pagination
                    currentPage={this.state.currentPage}
                    totalPage={this.state.totalPage}
                    onChange={this.getArticlesCategory}
                  />
                </div>
                <div class='col-lg-4 col-md-12 col-sm-12 primary-sidebar sticky-sidebar'>
                  <div class='widget-area pl-30'>
                    <div class='sidebar-widget widget-about mb-50 border-radius-5'>
                      <a
                        href='https://www.saobacdautelecom.vn?utm-source=smedx'
                        target='_blank'
                      >
                        <img src='/smedx/banners/ai-marketing.png' />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
          <Footer />
        </div>
      </CookiesProvider>
    );
  }
}
